import React from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import AppWithRedirect from './AppWithRedirect';
import reportWebVitals from './reportWebVitals';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
    const root = createRoot(document.getElementById('root'));

    root.render(
      <React.StrictMode>
          <MsalProvider instance={msalInstance}>
            <BrowserRouter>
              <AppWithRedirect />
            </BrowserRouter>
          </MsalProvider>
      </React.StrictMode>
    );

    // if (import.meta.env.VITE_APP_NODE_ENV !== undefined && import.meta.env.VITE_APP_NODE_ENV !== 'development') { console.log = () => {}; }

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
});